/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
 */
export interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {CredentialRead}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantId: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantEndpoint: string;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant
   */
  assistantApiVersion: string;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant interface.
 */
export function instanceOfSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant(
  value: object,
): value is SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  if (!('assistantEndpoint' in value) || value['assistantEndpoint'] === undefined) return false;
  if (!('assistantApiVersion' in value) || value['assistantApiVersion'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSON(
  json: any,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant {
  return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
    assistantEndpoint: json['assistant_endpoint'],
    assistantApiVersion: json['assistant_api_version'],
  };
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistantToJSON(
  value?: Omit<
    SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAzureOpenAiAssistant,
    'id' | 'credential'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
    assistant_endpoint: value['assistantEndpoint'],
    assistant_api_version: value['assistantApiVersion'],
  };
}
